import styled from "styled-components"

export const ButtonWrapper = styled.button`
    border-radius: 4px;
`
